/* Autoplay i ngadaltë për Featured Collection – punon si me scroll, si me butona */
(function () {
  const INTERVAL_MS = 4500;   // sa shpesh të kalojë në kartën tjetër
  const SCROLL_SPEED = 0.7;   // piksel për tick në modalitetin scroll
  const TICK_MS = 16;         // ~60fps
  const HOVER_PAUSE_MS = 8000;

  function ready(fn){ 
    if(document.readyState !== 'loading') fn(); 
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(() => {
    // Gjej të gjitha seksionet që duken si "featured collection" / karusel produktesh
    const sections = Array.from(document.querySelectorAll(
      [
        'section.featured-collection',
        '[data-section-type*="featured-collection"]',
        '.shopify-section:has(.featured-collection)',
        '.shopify-section:has(slider-component)',
        '.shopify-section:has(.slider)',
        '.shopify-section:has(.collection__slider)'
      ].join(', ')
    ));

    if (!sections.length) return;

    sections.forEach((section) => {
      // Gjej konteinerin që lëviz ose slider-in me butona
      const scroller =
        section.querySelector('slider-component [id^="Slider-"]') ||
        section.querySelector('.collection__slider') ||
        section.querySelector('.product-grid') ||
        section.querySelector('.slider') ||
        section.querySelector('[style*="overflow-x"], [class*="overflow-x"]');

      // Butonat e slider-it (nëse ekzistojnë)
      const nextBtn =
        section.querySelector('slider-component button[name="next"]') ||
        section.querySelector('.slider-button--next, [data-control="next"], [aria-label*="Next"]');
      const prevBtn =
        section.querySelector('slider-component button[name="previous"]') ||
        section.querySelector('.slider-button--prev, [data-control="prev"], [aria-label*="Previous"]');

      // Pause controls
      let pausedUntil = 0;
      const pause = (ms) => (pausedUntil = Date.now() + ms);
      const containersForPause = [section, scroller, nextBtn, prevBtn].filter(Boolean);
      containersForPause.forEach(el => {
        el.addEventListener('mouseenter', () => pause(Infinity));
        el.addEventListener('mouseleave', () => (pausedUntil = 0));
        ['wheel','touchstart','mousedown','keydown'].forEach(ev =>
          el.addEventListener(ev, () => pause(HOVER_PAUSE_MS), { passive: true })
        );
      });

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let inView = true;
      if ('IntersectionObserver' in window) {
        inView = false;
        const visibilityObserver = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
        });
        visibilityObserver.observe(section);
      }

      // ------------- MODE 1: SCROLL -------------
      if (scroller && scroller.scrollWidth > scroller.clientWidth + 10) {
        scroller.style.overflowX = scroller.style.overflowX || 'auto';
        function tick() {
          if (reduceMotion || document.hidden || !inView || Date.now() <= pausedUntil) return;
          scroller.scrollLeft += SCROLL_SPEED; // djathtas -> majtas
          if (scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1) {
            scroller.scrollLeft = 0; // loop
          }
        }
        setInterval(tick, TICK_MS);
        return; // mbaroi për këtë seksion
      }

      // ------------- MODE 2: CLICK NEXT -------------
      if (nextBtn) {
        setInterval(() => {
          if (reduceMotion || document.hidden || !inView || Date.now() <= pausedUntil) return;
          // provo Next → nëse jemi në fund, kthehu me Prev
          const disabled = nextBtn.disabled || nextBtn.getAttribute('aria-disabled') === 'true';
          if (disabled && prevBtn) {
            prevBtn.click(); // kthe një herë mbrapa që të lejojë loop
          } else {
            nextBtn.click();
          }
        }, INTERVAL_MS);
      }
    });
  });
})();
